<script>
import { formatNumber } from "../../helpers/formatting";

export default {
  props: {
    data: {
      type: Array,
      required: true,
    },
    totalHeight: {
      type: Number,
      default: 200,
    },
  },
  computed: {
    totalValue() {
      return this.data.reduce((sum, s) => sum + s.value, 0);
    },
    segmentsWithHeights() {
      const total = this.totalValue > 0 ? this.totalValue : 1; // prevent div/0
      return this.data.map((segment) => ({
        ...segment,
        height: (segment.value / total) * this.totalHeight,
      }));
    },
  },
  methods: {
    formatNumber,
  },
};
</script>

<template>
  <div class="flex flex-col mb-4">
    <div class="relative flex">
      <!-- Bar (stacked column) -->
      <div
        class="flex flex-col w-[45px] border-[1px] border-[#ccc] bg-slate-50 rounded-lg overflow-hidden"
        :style="{ height: totalHeight + 'px' }"
      >
        <div
          v-for="(segment, index) in segmentsWithHeights"
          :key="index"
          class="bar-segment w-full"
          :style="{
            height: segment.height + 'px',
            backgroundColor: segment.color,
          }"
        ></div>
      </div>

      <!-- Value column -->
      <div class="value-column" :style="{ height: totalHeight + 'px' }">
        <div
          v-for="(segment, index) in segmentsWithHeights"
          :key="'val-' + index"
          class="value-segment font-bold"
          :style="{ height: segment.height + 'px' }"
        >
          {{ segment.value ? formatNumber(segment.value) : "" }}
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.bar-segment {
  width: 100%;
  transition: height 0.3s ease;
}

.value-column {
  display: flex;
  flex-direction: column;
  margin-left: 12px;
  font-size: 13px;
}

.value-segment {
  display: flex;
  align-items: center;
  height: auto;
}
</style>
